<template>
  <el-drawer
    title="分润协议"
    :visible.sync="dividendAgreementVisible"
    direction="rtl"
    size="70%"
    @close="dividendAgreementVisibleClose"
  >
    <div class="box">
      <p>
        一、合同生效及失效：合同自签约盖章之日起生效，有效期与合同约定期限相同。如协议期内甲乙双方制定替代本协议的新协议，则本协议自动终止。如合同期满，须签署新的服务合同后，乙方可继续向甲方提供服务。
      </p>
      <p>
        此协议与《瑞启“WoYou工资”专业服务协议》（后续简称为“关联协议”）为关联协议，如关联协议失效，则本协议失效，乙方已知悉并确认本协议与关联协议的关系。
      </p>
      <p>二、合同约定项目</p>
      <p>
        1．乙方向甲方购买“WoYou工资”系统服务，并签署《瑞启“WoYou工资”专业服务协议》后，本协议下述商业条款生效。
      </p>
      <p>
        2．甲方依据瑞启线上服务协议、”WoYou工资”相关用户协议内容以及瑞启“WoYou工资”分润政策及甲方销售政策，向乙方支付互联网引流及数据服务费用。
      </p>
      <p>
        3．互联网引流及数据服务费用包含的项目及具体金额，依据甲方与其关联方（为甲方提供金融及保险服务的关联方或服务商）之间的对账清单及甲方分润政策及销售政策作为依据；乙方授权甲方使用乙方数据并进行对账。
      </p>
      <p>
        4．甲方与甲方关联方或业务服务商完成对账并满足支付条件后
        30日内，向乙方支付相关款项。
      </p>
      <p>
        5．乙方选定的收款方式为：□ 银行转账 □ 第三方支付（如微信/支付宝）转账
      </p>
      <p>
        6．乙方须甲方开具服务费发票，如不能开具发票的，甲方将采用代扣税费的方式先行扣除后，再向乙方支付有关费用。
      </p>
      <p>三、甲方的权利和义务</p>
      <p>
        1．甲方承诺不公开乙方的用户信息，除非乙方授权甲方透露这些信息，或相应的法律及程序要求甲方提供信息。
      </p>
      <p>2．甲方将不承担因乙方自身经营行为而产生的任何连带责任。</p>
      <p>
        3．在本协议有效期内，如因甲方关联方或服务商因自身或行业监管原因，不能继续履行对甲方的协议或承诺时，甲方将停止使用乙方提供的互联网引流及数据服务，但须提前15日告知乙方。
      </p>
      <p>四、乙方的权利和义务</p>
      <p>
        1．乙方可使用甲方提供的后台，用户名及密码，自协议及开户生效之日起查询可能产生的收益。
      </p>
      <p>
        2．乙方保证所经营及在“WoYou工资”系统内的数据及服务规范且真实合法，且不侵害任何第三方权益。如因此引发的账户被拒及任何法律纠纷，由乙方承担全部费用及法律责任，并赔偿甲方因此所受的全部损失和费用。
      </p>
      <p>
        五、争议解决：本合同的订立、效力、履行及因本协议所发生的一切纠纷，均应适用中华人民共和国法律。双方因本协议而发生的任何争议，应通过友好协商予以解决；若仍无法解决的，双方同意将争议提交协议甲方所在地法院裁决。
      </p>
      <p>
        六、其他：合同订立依据为瑞启线上服务协议及相关线上约定，解释权归属甲方。经双方签字盖章后，双方所执合同具有同等效力。
      </p>
    </div>
  </el-drawer>
</template>
<script>
export default {
  props: {
    visible: Boolean,
  },
  data() {
    return {
      dividendAgreementVisible: false,
    };
  },
  methods: {
    dividendAgreementVisibleClose() {
      this.$emit("close");
    },
  },
  watch: {
    visible(val) {
      this.dividendAgreementVisible = val;
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  padding: 25px;
  width: 100%;
  p {
    font-size: 16px;
    line-height: 38px;
  }
}
</style>